require('./FundBox.scss');

const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');
const classNames = require('classnames');
const { formatText } = require('core/i18n').i18n;
const { StarsRating } = require('commonsComponents/starsRating');
const RiskIndicator = require('../../components/RiskIndicator');
const { opened, closed } = require('../../actions/fundBox');
const { getTrailingPerformance } = require('../../selectors/fundDataSelectors');
const {
    MORNING_STAR_RATING_TIME_PERIOD,
    PRIIPKID_DOCUMENT,
    BUY_AND_HOLD_WITH_TAE_IN_DFI,
    BUY_AND_HOLD_WITHOUT_TAE_IN_DFI,
} = require("../../constants");
const { PRODUCTION_ENVIRONMENT } = require('constants/index');
const { NOT_ALLOWED_WEALTH_PRODUCT_NAME_FROM_CATALOGUE_COUNTRIES } = require('constants/flagBasedFeatures');


// @utilites
const { formatAmount, getPlainAmountObject, formatNumber, formatWithoutRound } = require('utilities/currencyHelper');
const { FormattedText } = require("core/i18n").i18n;
const { recordLinkCommonV2 } = require('commonsUtilities/tagging')

class FundBox extends React.Component {
    render() {
        const { fund, trailingPerformance, open, close, isOpen,catalogueDetails, immFeatureFlags } = this.props;     
        const allowCatalogueNames = immFeatureFlags.get(NOT_ALLOWED_WEALTH_PRODUCT_NAME_FROM_CATALOGUE_COUNTRIES);
        let ratingStars = 0 // when riskAndRating is undefined or it's empty

        if (fund.riskAndRating) {
            /**
             * "riskAndRating": [
             *   {
             *     "date": "2019-12-31T00:00:00",
             *     "timePeriod": "M255",
             *     "ratingValue": 2,
             *     "riskAdjustedReturn": 1.73,
             *     "riskRatingValue": 5,
             *     "riskScore": 2.47,
             *     "categoryRank": 74.38,
             *     "performanceRatingValue": 3,
             *     "performanceRatingCategoryRank": 64.43
             *   },
             *   ...
             * ],
             * ...
             */

            // select the item by a particular "timePeriod" ("M36", "M60", "M120", "M255", ...)

            const riskAndRatingSelectedItem = fund.riskAndRating
                .find(ratingByPeriod => ratingByPeriod.timePeriod === MORNING_STAR_RATING_TIME_PERIOD)
            if (riskAndRatingSelectedItem) {
                ratingStars = riskAndRatingSelectedItem.ratingValue
            }
        }

        const getUnits = (number) =>{
            if (number == null) {
                return 2;
            }
            return Number.isInteger(parseFloat(number)) ? 2 : number.toString().split('.')[1].length;
        }

        const handleSeeMoreClick = () => {
            const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
            recordLinkCommonV2({
                action: 'click',
                format: 'link',
                component: 'body',
                element: 'seeMoreInformation',
                eventCategory: 'fundDescriptionInteraction',
                eventAction: 'clickLink',
                eventLabel: 'seeMoreInformation',
            }, isNotProduction);
            return isOpen ? close() : open();
        }
        const managementFee = fund.hasOwnProperty('mifid') && catalogueDetails && catalogueDetails.mgmtFeeExAnte
            ? parseFloat(catalogueDetails.mgmtFeeExAnte)
            : 0;
        const fundCategory = !!fund.category ? formatText(`brokerAdvancedSearch-brokerAdvancedSearch_${fund.category}`) : '';
        const lastYearProfitabilityValue =
            !!fund.historicalPerformanceSeries &&
            !!fund.historicalPerformanceSeries[0] &&
            !!fund.historicalPerformanceSeries[0].return &&
            fund.historicalPerformanceSeries[0].return.find((value) => value.timePeriod === "M12")
        const lastYearProfitability = formatText('fundsCard-lastYearProfitabilityLabel');
        let performanceLastYear = '-';
        if (lastYearProfitabilityValue) {
            const performanceLastYearValue = lastYearProfitabilityValue.value;
            performanceLastYear = performanceLastYearValue ?
            formatWithoutRound(Number(performanceLastYearValue).toFixed(2)) + " %" :
            '-';
        }

        const getRiskValue = () => {
            const documentTypes = fund.documents.map(
                ({ documentTypes }) => documentTypes[0]
            );
            const isPRIIPKID = documentTypes.includes(PRIIPKID_DOCUMENT);
            if (isPRIIPKID && fund.kID && fund.kID.sRI) {
                return fund.kID.sRI;
            } else if (!isPRIIPKID) {
                return fund.collectedSRRI.rank;
            }
        };
        const regulatoryTextKeyArray = [];
        let regulatoryText;
        if (!!catalogueDetails && catalogueDetails.portfolio5) {
            if (
                catalogueDetails.portfolio5 === BUY_AND_HOLD_WITHOUT_TAE_IN_DFI
            ) {
                regulatoryTextKeyArray.push( "fundsCard-bHRegulatoryTextWithoutTAEs1");
                regulatoryTextKeyArray.push( "fundsCard-bHRegulatoryTextWithoutTAEs2");
                regulatoryText = (
                    <div>
                        <p>
                        <FormattedText
                            className="risk-indicator-risk-content__regulatory-text"
                            value={"fundsCard-bHRegulatoryTextWithoutTAEs1"}
                        />
                        </p>
                        <p>
                            <FormattedText
                                className="risk-indicator-risk-content__regulatory-text"
                                value={"fundsCard-bHRegulatoryTextWithoutTAEs2"}
                            />
                        </p>
                    </div>
                )
            } else if (
                catalogueDetails.portfolio5 === BUY_AND_HOLD_WITH_TAE_IN_DFI
            ) {
                regulatoryTextKeyArray.push("fundsCard-bHRegulatoryTextWithTAEs");
                regulatoryText = (
                    <p>
                        <FormattedText
                            className="risk-indicator-risk-content__regulatory-text"
                            value={"fundsCard-bHRegulatoryTextWithTAEs"}
                        />
                    </p>
                )
            }
        }

        const riskIndicatorSection =
            !!fund && !!fund.collectedSRRI && !!fund.collectedSRRI.rank ? (
                <div>
                    <section className="info--riskIndicator">
                        <RiskIndicator
                            riskValue={getRiskValue()}
                            regulatoryTextKeyArray={regulatoryTextKeyArray}
                        />
                    </section>
                    <hr className="info--divider" />
                </div>
            ) : (
                <div className="risk-indicator-risk-content__regulatory-text-container">
                    {regulatoryText}
                    <hr className="info--divider" />
                </div>
            );

        return(
            <div>
                <section className="info--account">
                    <h1 className="info--title">{allowCatalogueNames ? catalogueDetails.name : fund.name }</h1>
                    {formatText('fundsCard-isin')}:
                    &nbsp;
                    {fund.isin}
                </section>
                {riskIndicatorSection}
                <div className="risk-indicator-risk-content__regulatory-text-container">

                </div>


                <section>
                    <ul className="list-inline">
                        <li className="list-inline-item info--type">
                            {formatText('fundsCard-assetType')}
                            <div className="type--value">{fundCategory}</div>
                        </li>
                        <li className="list-inline-item info--location">
                            {formatText('fundsCard-assetSubtype')}
                            <div className="location--value">{fund.subCategory}</div>
                        </li>
                        <li className="list-inline-item info--currency">
                            {formatText('fundsCard-currency')}
                            <div className="currency--value">{fund.currency.id}</div>
                        </li>
                        <li className="list-inline-item info--action">
                            {formatText('fundsCard-accType')}
                            <div className="action--value">
                                {
                                    fund.accumulatedDistribution
                                    ? formatText('fundsCard-accumulatedAbbr')
                                    : formatText('fundsCard-distributedAbbr')
                                }
                            </div>
                        </li>
                        <li className="list-item info--gestor">
                            {formatText('fundsCard-administrator')}
                            <span>{ allowCatalogueNames ? catalogueDetails.provider : fund.administratorCompany.name }</span>
                        </li>
                    </ul>
                </section>
                <section className="info__details">
                    <div className="details__value">
                        <p className="value--title">{formatText('fundsCard-lastPrice')}</p>
                        <p className="value--current">
                            { fund.lastPrice &&
                                <span>
                                    <span className="current--boldValue">{formatAmount(fund.lastPrice.value)}&nbsp;</span>
                                    <span className="current--bold">{getPlainAmountObject(fund.lastPrice.currency.id)}&nbsp;</span>
                                </span>
                            }
                            {trailingPerformance && trailingPerformance.return.find(r => r.timePeriod === 'D1')
                            ?
                            formatNumber(Number(trailingPerformance.return.find(r => r.timePeriod === 'D1').value).toFixed(2))
                            :
                            0}%&nbsp;
                            {trailingPerformance && trailingPerformance.return.find(r => r.timePeriod === 'D1') !== undefined &&
                                Number(trailingPerformance.return.find(r => r.timePeriod === 'D1').value) >= 0
                                ? <i className="icon-alza stock-exchange-index-variation__arrow--up" />
                                : <i className="icon-baja stock-exchange-index-variation__arrow--down" />
                            }
                        </p>
                    </div>
                    <button className="info__more" onClick={handleSeeMoreClick}>
                        Ver más información
                        &nbsp;
                        <i className={classNames('arrow--down', { open: isOpen })} />
                    </button>
                    <div className={classNames('details__rentability', { open: isOpen })}>
                        <p className="rentability--title">{formatText('fundsCard-profitabilityYTD')}</p>
                        <p className="rentability--current">
                            <span className="current--bold">
                                {trailingPerformance && trailingPerformance.return.find(r => r.timePeriod === 'M0')
                                ?
                                formatAmount(Number(trailingPerformance.return.find(r => r.timePeriod === 'M0').value).toFixed(2))
                                :
                                0}%
                            </span>
                        </p>
                    </div>
                    <div className={classNames('details__last-year-rentability', { open: isOpen })}>
                        <p className="last-year-rentability--title">{lastYearProfitability}</p>
                        <p className="last-year-rentability--current">
                            <span className="current--bold">
                                {performanceLastYear}
                            </span>
                        </p>
                    </div>
                    <div className={classNames('details__expenses', { open: isOpen })}>
                        <p className="expenses--title">{formatText('fundsCard-managementFees')}</p>
                        <p className="expenses--current">
                            <span className="current--bold">{formatAmount(managementFee, null, 2, !Number.isInteger(managementFee))}{'%'}</span>
                        </p>
                    </div>
                </section>
                <section className="info--rating">
                    <p className="rating--title">
                        {formatText('fundsCard-ratingMorningstar')}:
                    </p>
                    &nbsp;
                    <StarsRating total={5} actual={ratingStars} />
                </section>
                { !!fund.lastPrice &&
                    <p className="info__updated">
                        <FormattedText value='fundsCard-fundLastUpdatedAt' injectedStrings={[moment(fund.lastPrice.date).format('DD MMM YYYY')]}/>
                    </p>
                }
            </div>
        );
    }
}



FundBox.propTypes = {
    close: PropTypes.func.isRequired,
    fund: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    open: PropTypes.func.isRequired,
    trailingPerformance: PropTypes.object.isRequired,
    catalogueDetails: PropTypes.object.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => ({
    isOpen: state.brokerInvestmentFundView.fundboxOpen,
    trailingPerformance: getTrailingPerformance(state, props),
});

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(closed()),
    open: () => dispatch(opened()),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(FundBox);
